
import React, { useState } from 'react';
import { Typography } from '@material-ui/core';
import Button from '../../Button'
import Tooltip from '@material-ui/core/Tooltip';
import { RenderToolTip } from './index';
import { useCustomEventListener } from 'react-custom-events';
import * as EventApis from "relay/event";
import moment from "moment"
import { RecurringEvent } from "icons";


const getIntervalTime = (date) => {
  return moment(date).diff(moment(), 'seconds')
}

const getStatus = (status) => {
  switch (status) {
    case 'to_be_approved':
      return 'To Be Approved';
    case 'publish_scheduled':
      return 'Scheduled For Publish';
    case 'invite_scheduled':
      return 'Scheduled For Invite';
    default:
      return status;
  }
};

const eventStatusButtonText = (status, isApprover) => {
  switch (status) {
    case 'published':
      return 'schedule invite';
    case 'publish_scheduled':
      return 'publish now';
    case 'archived':
      return 'unarchive';
    case 'canceled':
      return 'duplicate';
    default:
      return isApprover ? 'review event' : 'edit';
  }
};


export default React.memo(({
  weekday,
  startTime,
  endTime,
  eventTitle,
  status,
  confirmedGuests,
  totalGuests,
  eventItem,
  classes,
  btnText,
  handlePrimaryAction,
  onRSVPClickedCallback,
  disabled,
  recurringEventType
}) => {

  const [event, setEvent] = React.useState({
    startTime,
    endTime,
    eventTitle,
    status,
    confirmedGuests,
    totalGuests,
    weekday,
    recurringEventType
  })

  const [buttonText, setButtonText] = React.useState(btnText)


  const refresh = async (notifications) => {
    let needToUpdate = notifications.find(i => i.sourceId === eventItem.id && event.status !== i.notifStatus);
    if (needToUpdate) {
      let updatedEvent = await EventApis.getEventlessFields(eventItem.id);
      if (updatedEvent && updatedEvent.hyevent) {
        updatedEvent = updatedEvent.hyevent
        setEvent({
          ...event,
          eventTitle: updatedEvent.title,
          totalGuests: updatedEvent.maxNoOfGuests,
          status: getStatus(updatedEvent.status),
          confirmedGuests: updatedEvent.rsvpedCount,
          // startAt
          // endAt
        })
        setButtonText(eventStatusButtonText(updatedEvent.status, eventItem.isApprover))
      }
    }
  }
  useCustomEventListener("agentNotif", refresh);

  React.useEffect(() => {
    var interval;
    if (eventItem.publishTime) {
      let time = getIntervalTime(eventItem.publishTime);
      if (time > 0 && time < 10000) {
        time = time + 20
        interval = setTimeout(() => {
          doUpdate()
        }, time * 1000)
      }
    }

    return () => {
      if (interval) clearTimeout(interval)
    }
  }, [1]);

  const doUpdate = async () => {
    console.log("verifying for publish..." + event.eventTitle)
    let updatedEvent = await EventApis.getEventlessFields(eventItem.id);
    if (updatedEvent && updatedEvent.hyevent) {
      console.log("updatedEvent.hyevent.status: ", updatedEvent.hyevent.status)
      if (updatedEvent.hyevent.status !== "published") {
        setTimeout(() => {
          doUpdate();
        }, 3000)
      }
      else {
        setEvent({ ...event, status: getStatus(updatedEvent.hyevent.status) })
        setButtonText('schedule invite')
      }
    }
  }

  const _handlePrimaryAction = () => {
    handlePrimaryAction(buttonText)
  }

  return (
    <>
      <div className={classes.weekmonthcontainer}>
        <Typography className={classes.monthweekText} variant='body1'>
          {event.weekday}
        </Typography>
        <Typography className={classes.time} variant='subtitle1'>
          {`${event.startTime} - ${event.endTime}`}
        </Typography>
      </div>
      <div className={classes.textWrapperLarge}>
        <Tooltip title={event.eventTitle} aria-label='add' arrow>
          <Typography className={classes.eventname} variant='body1'>
            {event.eventTitle}
          </Typography>
        </Tooltip>
        {
          event.recurringEventType == "recurring" ? <RecurringEvent /> : null
        }
      </div>
      <div className={classes.textWrapper}>
        <Typography className={classes.rsvp} variant='body1' onClick={() => {
          onRSVPClickedCallback(eventItem);
        }}>
          {`${event.confirmedGuests}/${event.totalGuests} RSVPs`}
        </Typography>
      </div>
      <div className={classes.textWrapperSmall}>
        <RenderToolTip
          status={event.status}
          eventItem={eventItem}
        />
        {/* {RenderToolTip(status, eventItem)} */}
      </div>
      <Button
        variant='secondary'
        size='sm'
        color='primary'
        disabled={disabled === eventItem.id}
        className={classes.btn}
        onClick={_handlePrimaryAction}
      >
        {buttonText}
      </Button>
    </>
  )
})